
import * as handlebars_family from "./handlebars_family.ts";
import "./layout/layout_global.mustache";
const TPL = handlebars_family.addTemplate("page_contacts",{"1":function(container,depth0,helpers,partials,data) {
    return " <flexcol class=\"pane-left\" style=\"max-width:400px\"></flexcol><flexauto class=\"pane-main\" style=\"border-left:var(--border);\"></flexauto> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_global"),depth0,{"name":"layout/layout_global","hash":{"addButton":"contactnew","pageKey":"mainMenu.contacts","isPageContact":true},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;